import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get targets() {
        return ["showAllButton", "filterButton", "filterForm", "allTypesFilterCheckbox", "typeFilterCheckbox", "teamFilterCheckbox"];
    }

    connect() {
        this.updateButtons();
    }

    showAll(e) {
        e.preventDefault();
        this.allTypesFilterCheckboxTarget.checked = true;
        this.allTypesFilterCheckboxTarget.disabled = true;
        [...this.typeFilterCheckboxTargets, ...this.teamFilterCheckboxTargets].forEach(fct => {
            fct.checked = false;
        });
        this.updateButtons();
        this.filterFormTarget.dispatchEvent(new CustomEvent("feed:filter-changed"));
    }

    filterChanged(e) {
        if (e.target === this.allTypesFilterCheckboxTarget || this.typeFilterCheckboxTargets.some(tfct => tfct === e.target)) {
            if (e.target === this.allTypesFilterCheckboxTarget) {
                this.typeFilterCheckboxTargets.forEach(tfct => {
                    tfct.checked = false;
                });
            } else {
                this.allTypesFilterCheckboxTarget.checked = this.typeFilterCheckboxTargets.every(tfct => !tfct.checked);
            }

            this.allTypesFilterCheckboxTarget.disabled = this.allTypesFilterCheckboxTarget.checked;
        }

        this.updateButtons();
        this.filterFormTarget.dispatchEvent(new CustomEvent("feed:filter-changed"));
    }

    updateButtons() {
        const isFiltered = this.typeFilterCheckboxTargets.some(tfct => tfct.checked) || this.teamFilterCheckboxTargets.some(tfct => tfct.checked);
        this.showAllButtonTarget.classList.toggle("filter-selected", !isFiltered);
        this.filterButtonTarget.classList.toggle("filter-selected", isFiltered);
    }
}